import React from 'react'
import { Platform, View } from 'react-native'
import OpticalMeasureDevTile from 'features/debug/OpticalMeasureDevTile'
import { useTranslation } from 'react-i18next'

import Page from '@shell/Page'
import ButtonsFixed, { SpaceButtons } from '@ui/buttons/ButtonsFixed'
import useStartOrder from '@order/hooks/useStartOrder'
import Welcome from './sections/Welcome'
import Deals from './sections/Deals'
import Credits from './sections/Credits'
import Order from './sections/Order'
import Orders from './sections/Orders'
import Frames from './sections/Frames'
import Eyetest from './sections/Eyetest'
import Consultant from '@screens/intro/avatar/sections/Consultant'
// import useCheckCustomer from './useCheckCustomer'
import useAppModes from 'hooks/useAppModes'
import useCustomerInvoice from 'hooks/useCustomerInvoice'
import { trpc } from 'api'
import { router } from 'expo-router'
import { useCurrentScenario } from '@order/hooks/useScenario'
import { useDiscountTypeEnabled } from '@order/useDiscounts'
import { useActiveDeal } from '@order/hooks/useDeal'
import { useConfigCondition } from 'features/config/useConfigCondition'
import { ORDER_HISTORY } from 'features/config/ConfigConditionSchemas'

export default function CustomerHome() {
  const { t } = useTranslation(['ui'])
  const isWeb = Platform.OS === 'web'
  const startOrder = useStartOrder()
  // After AuthRedirect fixes this should be un needed
  // useCheckCustomer()
  // Preload customer invoice
  useCustomerInvoice()
  // Preload interests
  trpc.customer.interests.get.useQuery()
  const deal = useActiveDeal()

  const { isAvatar } = useAppModes()
  const scenario = useCurrentScenario()
  const isCreditsEnabled = useDiscountTypeEnabled('credit', scenario)
  const showOrderHistory = useConfigCondition(ORDER_HISTORY)

  return (
    <>
      <Page stage="customer" back={() => router.navigate('/staff/panel')}>
        <View className="gap-8 p-8 pt-0">
          <OpticalMeasureDevTile />
          <Welcome />
          {isAvatar && <Consultant onPress={() => startOrder('avatar')} />}
          <View className="w-full flex-row gap-8">
            <Deals />
            <Credits disabled={!isCreditsEnabled} />
          </View>
          {showOrderHistory ? (
            <>
              <Order size="large" />
              <View className="w-full flex-row gap-8">
                <Orders />
                <Eyetest />
              </View>
            </>
          ) : (
            <>
              <View className="w-full flex-row gap-8">
                <Order size="small" />
                <Eyetest />
              </View>
            </>
          )}
          <View className="w-full flex-row gap-8">
            <Frames />
          </View>
          <SpaceButtons />
        </View>
      </Page>
      <ButtonsFixed
        buttons={[
          {
            variant: 'filled',
            label: isAvatar ? t('ui:startGuidance') : t('ui:startOrder'),
            iconEnd: 'arrow-narrow-right',
            onPress: () =>
              startOrder(isAvatar ? 'avatar' : deal?.settings?.flow),
          },
        ]}
      />
    </>
  )
}
